import isEmpty from "../../validation/is-empty";
import {
  CANCEL_CHK_PAYMENT_SUCCESS,
  CANCEL_CHK_PAYMENT_FAILED,
  CANCEL_CHK_PAYMENT_LOADING,
  RESET_CANCEL_CHK_PAYMENT,
  CANCEL_CHK_PAYMENT_NETWORK_ERROR
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  networkError: false,
  data: {},
  description: '',
};
// data: action.payload,
export default (state = initialState, action) => {
  switch (action.type) {

    case CANCEL_CHK_PAYMENT_LOADING:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        networkError: false,
        data: {},
        description: '',
      };

    case CANCEL_CHK_PAYMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        networkError: false,
        data: action.payload,
        description: action.payload.status
      };

    case CANCEL_CHK_PAYMENT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        networkError: false,
        data: action.payload,
        description: action.payload.status
      };

    case CANCEL_CHK_PAYMENT_NETWORK_ERROR:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        networkError: true,
        data: action.payload,
        description: "Cannot connect to the server !"
      };

    case RESET_CANCEL_CHK_PAYMENT:
      return (state = initialState);


    default:
      return state;
  }
};
